import { Checkbox } from '../ui/checkbox'
import { cn } from '@/lib/utils'

interface CheckboxSelectProps {
  id: string
  checked: boolean
  onChange: (checked: boolean) => void
  label: string
  description?: string
  checkboxClass?: string
  labelClass?: string
  descriptionClass?: string
  containerClass?: string
}

const CheckboxSelect = ({
  id,
  checked,
  onChange,
  label,
  description,
  checkboxClass,
  labelClass,
  descriptionClass,
  containerClass,
}: CheckboxSelectProps) => {
  const handleContainerClick = () => {
    onChange(!checked)
  }

  const handleCheckboxClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  const handleLabelClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  return (
    <div
      className={cn(
        'flex items-center space-x-3 cursor-pointer',
        containerClass
      )}
      onClick={handleContainerClick}
    >
      <div onClick={handleCheckboxClick}>
        <Checkbox
          id={id}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className={checkboxClass}
        />
      </div>
      <div className='flex-1'>
        <label
          htmlFor={id}
          className={cn(
            'text-sm font-medium text-gray-900 cursor-pointer',
            labelClass
          )}
          onClick={handleLabelClick}
        >
          {label}
        </label>
        <p className={cn('text-xs text-gray-500 mt-1', descriptionClass)}>
          {description}
        </p>
      </div>
    </div>
  )
}

export default CheckboxSelect
